import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-zinc-500 font-mono-data text-sm">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
}
